import apiClient from './client';

/** 관리자: 코트별 진행 중인 경기 전체 (모든 대회, 코트 순). 없으면 [] */
export async function fetchLiveMatches() {
  const { data } = await apiClient.get('/admin/competition-live-match');
  return Array.isArray(data) ? data : [];
}

/** 관리자: 경기 시작 (그 코트의 이전 경기는 해제, 이 경기가 다른 코트에 있으면 이 코트로 옮김) */
export async function startLiveMatch({ court, tournamentId, divisionKey, roundIndex, matchIndex }) {
  const { data } = await apiClient.post('/admin/competition-live-match/start', {
    court,
    tournamentId,
    divisionKey,
    roundIndex,
    matchIndex,
  });
  return data;
}

/** 관리자: 그 코트의 경기 종료 (점수는 그대로 남는다) */
export async function endLiveMatch(court) {
  await apiClient.post('/admin/competition-live-match/end', { court });
}
